import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { formatDate } from '../../../utils/formatters';
import MapController from './MapController';
import createCustomIcon from './CustomMarker';

// Fix for Leaflet icon image path issue in some environments
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
});

/**
 * Map view component
 * @param {Object} props - Component props
 * @param {Array} props.events - Events to display on map
 * @param {Object} props.selectedEvent - Currently selected event
 * @param {Array} props.mapCenter - Default map center [lng, lat]
 * @param {number} props.mapZoom - Default map zoom level
 * @param {Function} props.onEventSelect - Event selection handler
 * @param {boolean} props.isModalOpen - Whether a modal is currently open
 */
const MapView = ({ events, selectedEvent, mapCenter, mapZoom, onEventSelect, isModalOpen }) => {
  return (
    <div className="w-full h-full bg-gray-100 relative">
      <div className={`absolute inset-0 ${isModalOpen ? 'pointer-events-none' : ''}`}>
        <div className="absolute bottom-0 right-0 z-10 bg-white bg-opacity-80 px-2 py-1 text-xs text-gray-600 rounded-tl-md">
          BMW Art Car Collection 50th Anniversary World Tour
        </div>
        <MapContainer 
          center={[mapCenter[1], mapCenter[0]]} 
          zoom={mapZoom} 
          style={{ height: '100%', width: '100%' }}
          zoomControl={true}
          attributionControl={true}
          id="main-map"
          // Slightly lower z-index for map container
          className="z-0"
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
            url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
          />
          
          <MapController 
            center={selectedEvent ? [selectedEvent.coordinates[1], selectedEvent.coordinates[0]] : undefined} 
            zoom={selectedEvent ? 6 : undefined} 
          />
          
          {events.map((event) => {
            const isSelected = selectedEvent?.id === event.id;
            const isActive = event.active;
            
            return (
              <Marker 
                key={event.id} 
                position={[event.coordinates[1], event.coordinates[0]]}
                icon={createCustomIcon(isActive, isSelected)}
                eventHandlers={{
                  click: () => onEventSelect(event),
                }}
              >
                <Popup>
                  <div className="text-sm">
                    <strong>{event.location}</strong><br />
                    {event.venue}<br />
                    {formatDate(event.startDate)} - {formatDate(event.endDate)}<br />
                    {event.cars.length} car{event.cars.length !== 1 ? 's' : ''}
                    {event.active && (
                      <div className="mt-1 text-green-600 font-medium">
                        Currently on display
                      </div>
                    )}
                  </div>
                </Popup>
              </Marker>
            );
          })}
        </MapContainer>
      </div>
    </div>
  );
};

export default MapView;